import ShopComponent from '../components/shops/shops'

const Shops = () => <ShopComponent />

export default Shops;